import React from "react"
import Copyright from './Copyright';
import Sitemap from './Sitemap';
import SocialMedia from './SocialMedia';
import styled from '@emotion/styled';
import * as breakpoint from '../../styles/breakpoints.module.scss';


const Footer = () => {
  
  return(
    <>
      <FooterWrapper>
        <div>
          <Sitemap />
          <SocialMedia />
        </div>
      </FooterWrapper>
      <Copyright />
    </>)
}

export default Footer;


const FooterWrapper = styled.footer`
  background:#343739;
  padding:96px 0;
  position:relative;

  >div{
    position:relative;
    margin:0 auto;
    max-width:928px;
  }

  @media only screen and (max-width: ${breakpoint.smMax}){
    padding:64px 0;
  }
`
